import { useT } from '@kmgestao/i18n';
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  toast,
} from '@kmgestao/ui';

import { useDeleteClinicByok } from '../../../../features/ai-clinic/index.js';

export interface ByokDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  clinicId: string;
}

export function ByokDeleteDialog({ open, onOpenChange, clinicId }: ByokDeleteDialogProps) {
  const { t } = useT('ai-clinic');
  const { t: tCommon } = useT('common');
  const mutation = useDeleteClinicByok();

  const handleConfirm = async () => {
    try {
      await mutation.mutateAsync({ clinicId });
      toast.success(t('byok.delete.success'));
      onOpenChange(false);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : t('byok.delete.error'));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('byok.delete.title')}</DialogTitle>
          <DialogDescription>{t('byok.delete.description')}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button type="button" variant="outline">
              {tCommon('actions.cancel')}
            </Button>
          </DialogClose>
          <Button
            type="button"
            variant="destructive"
            onClick={handleConfirm}
            disabled={mutation.isPending}
          >
            {mutation.isPending ? tCommon('status.loading') : t('byok.delete.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
